import { milesToKm } from '@shared/utils/milesToMeters';

export const DEFAULT_ZOOM = 13;

export const DEFAULT_RADIUS_KM = milesToKm(2); // ~3.2 km

// Minimum zoom level to show "Search this area" CTA (8 = city-level view)
export const MIN_SEARCH_ZOOM = 8;

export const ZOOM_PAN_CONDITIONS = [
  { zoom: 18, distance: 120 },
  { zoom: 17, distance: 250 },
  { zoom: 16, distance: 500 },
  { zoom: 15, distance: 1000 },
  { zoom: 14, distance: 2000 },
  { zoom: 13, distance: 4000 },
  { zoom: 12, distance: 8000 },
  { zoom: 11, distance: 15000 },
  { zoom: 10, distance: 30000 },
  { zoom: 8, distance: 130000 },
  { zoom: 6, distance: 500000 },
  { zoom: 4, distance: 2000000 },
  { zoom: 2, distance: 6000000 },
];

export const PANEL_DISTANCE_MULTIPLIER = 1.5; // When panel hide it increase map size

export const DEBOUNCE_TIMEOUT_MS = 1000;
